export default __webpack_public_path__ + "static/media/medical-equipment-icon.af874ce1.svg";